import {LOGIN, LOGOUT,LOAN_UPDATED,PASSWROD_RESET_MODE,PASSWORD_RESET_REQUEST_SUCCESS,PASSWORD_RESET_REQUEST_ERROR, AUTHENTICATION_SUCCESS, AUTHENTICATE, AUTHENTICATION_FAILED,PASSWORD_RESET_ERROR,PASSWORD_RESET_SUCCESS,RESET_PASSWORD,ACCOUNT_UPDATED} from '../actions/types';

const initialState=
{
    logged:false,
    auth_failed:false,
    account:null,
    resetting_password:false,
    reset_error:false,
    reset_success:false,
    authenticating:true,
    mode:'default',
    reset_request_error:false,
    reset_request_success: false,
    errorMessage: ""
}

export default function(state = initialState, action)
{
    switch(action.type)
    {
        case LOAN_UPDATED:
            return {
                ...state,
                account:{...state.account,must_update:false}
            };
        case RESET_PASSWORD:
            return {
                ...state,
                mode:'reset',
                reset_error:false,
                reset_success:false
            };
        case PASSWORD_RESET_ERROR:
            return {
                ...state,
                reset_error:true,
                reset_success:false
            };
        case PASSWORD_RESET_REQUEST_SUCCESS:
            return {
                ...state,
                reset_request_error:false,
                reset_request_success:true
            };
        case PASSWORD_RESET_REQUEST_ERROR:
            return {
                ...state,
                reset_request_error:true,
                reset_request_success:false
            };
        case PASSWORD_RESET_SUCCESS:
            return {
                ...state,
                reset_error:false,
                reset_success:true
            };
        case PASSWROD_RESET_MODE:
            return {
            ...state,
            mode: 'password'}
        case LOGIN:
            return {
                ...state,
                mode: 'login',
                logged:false,
                auth_failed:false,
                authenticating:false,
                reset_request_error:false,
                reset_request_success:false
            }
        case LOGOUT:
            return {
                ...state,
                account:null,
                mode: 'default',
                logged:false,
                auth_failed:false,
                authenticating:false,
                reset_request_error:false,
                reset_request_success:false
            }
        case AUTHENTICATION_SUCCESS:
            return {
                ...state,
                mode:'default',
                logged:true,
                auth_failed:false,
                account:action.payload,
                authenticating:false
            };
        case ACCOUNT_UPDATED:
            return {
                ...state,
                account:action.payload
            }
        case AUTHENTICATE:
            return {
                ...state,
                logged:false,
                auth_failed:false,
                account:null
            }
        case AUTHENTICATION_FAILED:
        return {
            ...state,
            logged:false,
            auth_failed: true,
            errorMessage: action.payload,
            account:null
            }
        default:
            return state;
    }
}